import { createRouter, createWebHistory } from "vue-router";
import blog from "@/components/blog/blog.json";
import i18n from "@/i18n";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home/MainPage.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro",
    name: "home-ro",
    component: () => import("../views/home/MainPage.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutUs.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/despre-noi",
    name: "about-ro",
    component: () => import("../views/AboutUs.vue"),
    meta: { locale: "ro" },
  },
  // Services sub-items (located in views/myservices)
  {
    path: "/web-development",
    name: "web-development",
    component: () => import("../views/myservices/WebDevelopment.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/dezvoltare-web",
    name: "web-development-ro",
    component: () => import("../views/myservices/WebDevelopment.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/cybersecurity-solutions",
    name: "cybersecurity-solutions",
    component: () => import("../views/myservices/CybersecuritySolutions.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/solutii-securitate-cibernetica",
    name: "cybersecurity-solutions-ro",
    component: () => import("../views/myservices/CybersecuritySolutions.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/custom-ai-development-and-automation",
    name: "custom-ai-development-and-automation",
    component: () => import("../views/myservices/CustomAiDevelopment.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/dezvoltare-ai-personalizata-automatizare",
    name: "custom-ai-development-and-automation-ro",
    component: () => import("../views/myservices/CustomAiDevelopment.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/ai-secure-infrastructure",
    name: "ai-secure-infrastructure",
    component: () => import("../views/myservices/AiSecureInfrastructure.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/infrastructura-ai-securizata",
    name: "ai-secure-infrastructure-ro",
    component: () => import("../views/myservices/AiSecureInfrastructure.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/ai-red-teaming",
    name: "ai-red-teaming",
    component: () => import("../views/myservices/AiRedTeaming.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/ai-red-teaming",
    name: "ai-red-teaming-ro",
    component: () => import("../views/myservices/AiRedTeaming.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/ai-systems-hardening",
    name: "ai-systems-hardening",
    component: () => import("../views/myservices/AiSystemsHardening.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/securizare-sisteme-ai",
    name: "ai-systems-hardening-ro",
    component: () => import("../views/myservices/AiSystemsHardening.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/portofolio",
    name: "Portofolio",
    component: () => import("../views/portfolio/grids/PortofolioCl.vue"),
  },
  {
    path: "/grid-3-columns",
    name: "grid-3-columns",
    component: () => import("../views/portfolio/grids/GridThree.vue"),
  },
  {
    path: "/embrace-holistic-health",
    name: "embrace-holistic-health",
    component: () => import("../views/portfolio/projects/EmbraceHolistic.vue"),
  },
  {
    path: "/bastian-bux",
    name: "bastian-bux",
    component: () => import("../views/portfolio/projects/BastianBux.vue"),
  },
  {
    path: "/odd-watch-company",
    name: "odd-watch-company",
    component: () => import("../views/portfolio/projects/OddWatch.vue"),
  },
  {
    path: "/jmc-hockey",
    name: "jmc-hockey",
    component: () => import("../views/portfolio/projects/JmcHockey.vue"),
  },
  {
    path: "/nextgenai-consulting",
    name: "next-gen-ai-consulting",
    component: () => import("../views/portfolio/projects/NextGen.vue"),
  },
  {
    path: "/thehurriyastore",
    name: "thehurriyastore",
    component: () => import("../views/portfolio/projects/TheHurriyaStore.vue"),
  },
  {
    path: "/rootspice",
    name: "rootspice",
    component: () => import("../views/portfolio/projects/RootSpice.vue"),
  },
  {
    path: "/brunel-chauffeurs",
    name: "brunel-chauffeurs",
    component: () => import("../views/portfolio/projects/BrunelChauffeurs.vue"),
  },
  {
    path: "/novafit",
    name: "novafit",
    component: () => import("../views/portfolio/projects/NovaFit.vue"),
  },
  {
    path: "/toast-reel",
    name: "toast-reel",
    component: () => import("../views/portfolio/projects/ToastReel.vue"),
  },
  {
    path: "/hexcars-uk",
    name: "hex-cars-uk",
    component: () => import("../views/portfolio/projects/HexCars.vue"),
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("../views/blog/BlogList.vue"),
  },
  {
    path: "/article/:id",
    name: "article",
    component: () => import("../views/blog/BlogDetails.vue"),
    beforeEnter(to, from, next) {
      const id = parseInt(to.params.id);
      const LocalArticles = blog;
      const exists = LocalArticles.some((article) => article.id === id);
      if (exists) {
        next((vm) =>
          vm.getData({
            path: to.query.page,
            replace: true,
          })
        );
      } else {
        next({
          path: "not-found",
          replace: true,
        });
      }
    },
  },
  {
    path: "/slider",
    name: "slider",
    component: () => import("../views/portfolio/slider/SliderFullScreen.vue"),
  },
  {
    path: "/slider-2",
    name: "slider-2",
    component: () => import("../views/portfolio/slider/SliderPadding.vue"),
  },
  {
    path: "/slider-3",
    name: "slider-3",
    component: () => import("../views/portfolio/slider/SliderHalf.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactUs.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/contact",
    name: "contact-ro",
    component: () => import("../views/ContactUs.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/terms-and-conditions",
    name: "terms-and-conditions",
    component: () => import("../views/TermsAndConditions.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/termeni-si-conditii",
    name: "terms-and-conditions-ro",
    component: () => import("../views/TermsAndConditions.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: () => import("../views/CookiePolicy.vue"),
    meta: { locale: "en" },
  },
  {
    path: "/ro/politica-cookie",
    name: "cookie-policy-ro",
    component: () => import("../views/CookiePolicy.vue"),
    meta: { locale: "ro" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../views/CompError.vue"),
  },
];

const router = createRouter({
  // Using process.env.BASE_URL to handle the base URL dynamically
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
});

// URL is the source of truth for language on routes that have a locale
// (real /ro/* pages). Untranslated routes are left alone — the client-side
// toggle still works there via localStorage, same as before.
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.locale) {
    i18n.global.locale.value = to.meta.locale;
    try {
      localStorage.setItem('lang', to.meta.locale);
    } catch {
      // ignore in restricted environments
    }
  }
  next();
});

export default router;
